import React from 'react';
import { Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { reverse } from 'named-urls';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import RequestForChangesTableRow from './RequestForChangesTableRow';
import CommonTable from '../../common/components/CommonTable';
import { OrganizationChangeTypes } from '../../constants/OrganizationChangeTypes';
import RouterPaths from '../../constants/RouterPaths';
import CommonLoader from '../../common/components/CommonLoader';
import { SET_SELECTED_CHANGE_REQUEST } from '../RequestFormChangesReducer';

const headers = [
  {
    label: 'ID',
  },
  {
    label: 'Dealer',
  },
  {
    label: 'Change',
  },
  {
    label: 'Action',
    className: 'text-right',
  },
];

function RequestForChangesTable({ data, offset, changeOffset }) {
  const dispatch = useDispatch();
  const loaderStatus = useSelector((state) => state.requests.get('loaderStatus'));
  const navigate = useNavigate();

  const handleRedirectAction = (item) => {
    if (item.type === OrganizationChangeTypes.ADD_NEW_EMPLOYEE)
      return navigate(reverse(RouterPaths.EDIT_USER, { id: item?.value }));
    return navigate(reverse(RouterPaths.DEALER_INFORMATION, { id: item?.organization?.id }));
  };

  const handleRowClick = (item) => {
    dispatch({
      type: SET_SELECTED_CHANGE_REQUEST,
      payload: item.id,
    });
    handleRedirectAction(item);
  };

  return (
    <Row>
      <Col xs="12">
        <CommonLoader status={loaderStatus}>
          <CommonTable
            rowIdPrefix="change-request-row"
            rowComponent={RequestForChangesTableRow}
            data={data}
            offset={offset}
            onOffsetChange={changeOffset}
            headers={headers}
            title="Requests For Changes"
            onRowClick={handleRowClick}
          />
        </CommonLoader>
      </Col>
    </Row>
  );
}

RequestForChangesTable.propTypes = {
  changeOffset: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  offset: PropTypes.number.isRequired,
};

export default RequestForChangesTable;
